import React from "react";
import PropTypes from "prop-types";
import PopupWrapper from "@mnjsplatform/components/lib/common/PopupWrapper";
import ComplexParam from "@mnjsplatform/components/lib/common/ComplexParam";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import {connect} from "react-redux";
import i18next from "i18next";
import SearchBar from "@mnjsplatform/components/lib/common/SearchBar";

class FindForm extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      height: window.innerHeight
    };
  }

  async componentDidMount() {
    this.updateWindowHeight();
    window.addEventListener('resize', this.updateWindowHeight);
    await this.init();
  }

  init = async() => {
    try {
      let beginDateStr = this.props.beginDateStr;
      let endDateStr = this.props.endDateStr;

      if (!endDateStr) {
        endDateStr = this.dateToString(new Date());
      }
      if (!beginDateStr) {
        let beginDate = new Date(endDateStr);
        beginDate.setDate(beginDate.getDate() - 30);
        beginDateStr = this.dateToString(beginDate);
      }

      await this.props.dispatch(this.props.dataItem.execute({
        ...this.props.row,
        BeginDate: beginDateStr,
        EndDate: endDateStr
      }, {withParams: true}));
    }
    catch (e) {
      console.log(e);
    }
  };

  dateToString = (date) => {
    return date.toISOString().substr(0, 11) + "00:00:00";
  };

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowHeight);
  }

  updateWindowHeight = () => {
    this.setState({ height: window.innerHeight });
  };

  getGridContainerStyle = ({mobileMode}) => {
    let gridContainerStyle = {};
    if (!mobileMode) {
      const clientHeight = (this.state.height - 290) + "px";
      gridContainerStyle = {
        maxHeight: clientHeight,
        minHeight: "200px"
      };
    }
    return gridContainerStyle;
  };

  onSelect = (rowIndex, row, e) => {
    e.preventDefault();

    let fields = {...row};
    let columnsToDelete = this.props.dataItem.rawData.ResultFieldInfo
      .filter(c => c["IsArtificial"])
      .map(c => c.Name);
    columnsToDelete.push("#IDACKey#");//этой колонки нет в ResultFieldInfo
    columnsToDelete.forEach(c => { delete fields[c] });

    this.props.onSelect(fields);
  };

  requisitesParamRender = (h) => {
    return (
      <>
        <div className="row">
          <div className="col-md-1 field-title">
            {h.lbl("BeginDate")}
          </div>
          <div className="col-md-3">
            {h.ed("BeginDate")}
          </div>
          <div className="col-md-1 field-title">
            {h.lbl("EndDate")}
          </div>
          <div className="col-md-3">
            {h.ed("EndDate")}
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-md-1 field-title">
            {i18next.t("SearchLabel")}
          </div>
          <div className="col-md-11">
            <SearchBar dataItem={this.props.dataItem} />
          </div>
        </div>
      </>
    );
  };

  render() {
    if (!this.props.dataItem.isInitialized) {
      return null;
    }

    return (
      <PopupWrapper popupVisible
                    onClose={this.props.onClose}
                    title={this.props.title}
      >
        <ComplexParam dataItem={this.props.dataItemParams}
                      parentDataItem={this.props.dataItem}
                      rootPath="/"
                      showApplyButton={false}
                      autoApplyParams={true}
                      renderParams={this.requisitesParamRender}
        />

        <GridView dataItem={this.props.dataItem}
                  onRowClick={this.onSelect}
                  fixHeader={true}
                  contentContainerStyleProvider={this.getGridContainerStyle}
                  rowStyleProvider={() => ({cursor: "pointer"})}
                  headerStyleProvider={() => ({backgroundColor: "#ffffff"})}
                  updateStateFlag={{h: this.state.height}}
        />
      </PopupWrapper>
    );
  }
}

FindForm.propTypes = {
  dispatch: PropTypes.func,
  dataItem: PropTypes.object.isRequired,
  dataItemParams: PropTypes.object.isRequired,
  row: PropTypes.object.isRequired,
  title: PropTypes.string.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired
};

const mapStateToProps = (state, ownProps) => {
  return {
    transportReqParams: state.transportState.transportReqParams
  };
};

export default connect(mapStateToProps)(FindForm);